import type { SchemaDisplayMetadata } from '@reach/shared-types/schema-mappings';
import { SchemaIcon } from '@reach/web-ui/schema-display';
import React from 'react';
import type { TenantResourceData } from '../../../lib/tenant-api';
import { formatFieldValue } from './customObjectSchemas';

interface CustomObjectRowProps {
  externalId: string;
  resource: TenantResourceData;
  previewFields: string[];
  displayMetadata?: SchemaDisplayMetadata | null;
  onSelect: (externalId: string) => void;
}

export const CustomObjectRow: React.FC<CustomObjectRowProps> = ({
  externalId,
  resource,
  previewFields,
  displayMetadata,
  onSelect,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLTableRowElement>) => {
    const isActivationKey = event.key === 'Enter' || event.key === ' ';
    if (isActivationKey) {
      event.preventDefault();
      onSelect(externalId);
    }
  };

  return (
    <tr tabIndex={0} onClick={() => onSelect(externalId)} onKeyDown={handleKeyDown}>
      <td>
        <SchemaIcon displayMetadata={displayMetadata} size={16} />
        {externalId}
      </td>
      {previewFields.map(fieldName => (
        <td key={fieldName}>{formatFieldValue(resource[fieldName])}</td>
      ))}
    </tr>
  );
};
